import app from '../main'

window.axios = require('axios')
window.axios.defaults.baseURL = process.env.API_URL

axios.interceptors.request.use(config => {
  config.headers.Authorization = localStorage.getItem('token')
  app.$Progress.start()
  return config
})

axios.interceptors.response.use(response => {
  app.$Progress.finish()
  return response
})



// WEBPACK FOOTER //
// ./src/bootstrap/axios.js